import { docsBaseUrl } from '../contexts/environment';

const docsUrls = {
  root: '',
  awsUpdatePermissions: '/user-guide/aws/permissions/aws-update-permissions',
  awsSourcePermissionsChangelog:
    '/whats-new/permissions-changelogs/aws/source-permissions',
  awsRestorePermissionsChangelog:
    '/whats-new/permissions-changelogs/aws/restore-permissions',
  gcpSourcePermissionsChangelog:
    '/whats-new/permissions-changelogs/gcp/source-permissions',
  gcpRestorePermissionsChangelog:
    '/whats-new/permissions-changelogs/gcp/restore-permissions',
  azureSourcePermissionsChangelog:
    '/whats-new/permissions-changelogs/azure/source-permissions',
  azureRestorePermissionsChangelog:
    '/whats-new/permissions-changelogs/azure/restore-permissions',
  awsCustomizeRestoreServerConfig:
    '/user-guide/aws/restore-accounts/aws-customize-restore-server-configuration',
  azureSqlServerConfiguration:
    '/user-guide/azure/resources/sql-server-on-azure-vms#configuration',
  gcpCustomizeRestoreServerConfig:
    '/user-guide/gcp/restore-projects/gcp-customize-restore-server-configuration',
  vaultSelfManagedKeys:
    '/user-guide/backing-up/vaults/about-self-managed-vault-keys',
  restoreAccountNetworkConnectivity:
    '/user-guide/restoring/restore-accounts/about-restore-accounts#the-restore-server-and-its-network-connectivity',
  queryDatabaseSnapshots:
    '/user-guide/searching-exploring-and-querying/query/query-database-snapshots',
} as const;

export const getDocsUrl = (key: keyof typeof docsUrls) =>
  `${docsBaseUrl}${docsUrls[key]}`;
